import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { GetUserProjectAction } from '../../../redux/actions/user';
import { DELETE_PROJECT_RESET } from '../../../redux/constantes/project';

import { ContainerForm } from '../../../components/Containers';
import Title from '../../../components/SincronizaNFe/TitleSincroniza';
import ButtonBack from '../../../components/ButtonBack';
import { MessageBoxAlert, MessageBoxError } from '../../../components/MessageBox';
import WrapperListHeader from '../../../components/SincronizaNFe/WrapperListHeader';
import { WrapperCard } from '../../../components/SincronizaNFe/WrapperCards';
import Card from '../../../components/SincronizaNFe/Card';

export default function TemplateListProjectsAndCreateAndEdit() {
  const { userInfo } = useSelector((state) => state.userSign);
  const { loading, error: errorListProjects, listProjects } = useSelector((state) => state.getUserProject);
  const { error: errorDelete, success: successDelete } = useSelector((state) => state.deleteProject);
  const dispatch = useDispatch();

  useEffect(() => {
    if (errorListProjects === 'Token inválido') {
      localStorage.removeItem('userInfo');
      document.location.href = '/login';
    }
  }, [errorListProjects]);

  useEffect(() => {
    if (successDelete) {
      dispatch({ type: DELETE_PROJECT_RESET });
    }
    if (errorDelete) {
      setTimeout(() => {
        dispatch({ type: DELETE_PROJECT_RESET });
      }, 3000);
    }
    if (userInfo !== null) {
      dispatch(GetUserProjectAction(userInfo._id));
    }
  }, [userInfo, dispatch, errorDelete, successDelete]);

  return (
    <ContainerForm>
      <Title text="Apoio ao Faturamento do Prestador de Serviço" />
      <ButtonBack />
      <WrapperListHeader />
      <WrapperCard>
        {listProjects &&
          listProjects.map((list) => {
            return <Card key={list._id} list={list} />;
          })}
      </WrapperCard>
      {loading && <MessageBoxAlert>Carregando...</MessageBoxAlert>}
      {errorDelete && <MessageBoxError>{errorDelete}</MessageBoxError>}
      {errorListProjects && <MessageBoxAlert>Você ainda não possui nenhum faturamento!</MessageBoxAlert>}
    </ContainerForm>
  );
}
